import styled from 'styled-components';

const InfoText = styled.span`
    font-size: 12px;
    color: ${props => props.theme.colors.greyXXD}
`;

export default styled(InfoText)``;
